import { FilterCriteria } from '../../FilterStore'
import { FilterChipCloseButton, FilterChipContainer } from './FilterChipStyles'
import { useTableLinkVariant } from 'components/Tables/CommonTableCells/TableLinkStyleContext'

export function FilterChipSearch({
  search,
  onClose,
  searchLabel = 'Search',
  filterCriteria = 'all',
  isHovered,
}: {
  search: string
  onClose?: () => void
  searchLabel?: string
  filterCriteria?: FilterCriteria
  isHovered?: boolean
}) {
  const variant = useTableLinkVariant()
  const isPlain = variant === 'plain'
  if (!search) return null
  const isExclusive = filterCriteria === 'neither'
  return (
    <FilterChipContainer
      $isExclusive={isPlain ? false : isExclusive}
      isHovered={isHovered}
    >
      <span>
        {`${searchLabel}: `}
        {isPlain && isExclusive ? <b>NOT </b> : null}
        <b>{search}</b>
      </span>
      {onClose && (
        <FilterChipCloseButton
          $isExclusive={isPlain ? false : isExclusive}
          onClick={onClose}
        />
      )}
    </FilterChipContainer>
  )
}
